<div
	class="wrapper"
	[class.search-initiated]="keywordControl.value"
	matAutocompleteOrigin
	#origin="matAutocompleteOrigin"
>
	<mat-icon class="me-2" [class.hidden-state]="keywordControl.value">search</mat-icon>
	<input
		type="text"
		matInput
		#trigger="matAutocompleteTrigger"
		placeholder="{{ 'mep.components.global-search.search' | translate }}"
		[formControl]="keywordControl"
		[matAutocomplete]="auto"
		[matAutocompleteConnectedTo]="origin"
		(keyup.enter)="search(); trigger.closePanel()"
	/>
	@if (globalLoading) {
		<mat-progress-spinner mode="indeterminate" diameter="15" class="pe-2 me-2"></mat-progress-spinner>
	}
	<mat-icon
		class="global-search-info"
		matTooltip="{{ 'mep.components.global-search.search-tooltip' | translate }}"
		matTooltipClass="custom-tooltip"
		>info
	</mat-icon>
</div>
<mat-autocomplete #auto="matAutocomplete" class="global-search-autocomplete">
	@if (keywordControl.value && keywordControl.value !== "") {
		@for (option of proposalFilteredOptions | async; track option) {
			<a>
				<mat-option
					(onSelectionChange)="navigateToOptionRouterLink(option)"
					(mouseup)="navigateToOptionInNewTab(option, $event.button)"
				>
					<mat-icon>{{ option.icon }}</mat-icon>
					{{ option.identificator }}
				</mat-option>
			</a>
		}
	}

	<a routerLink="/global-search" [queryParams]="{keyword: keywordControl.value}">
		@if (keywordControl.value && keywordControl.value !== "") {
			<mat-option class="full-search-link" [value]="keywordControl.value">
				<mat-icon>search</mat-icon>
				'{{ keywordControl.value.trim() }}' {{ "mep.components.global-search.full-search" | translate }}
			</mat-option>
		}
	</a>
</mat-autocomplete>
